import { Alpine } from "alpinejs";
import { alpineData } from "./alpine-data";
import { studioConfirm } from "./studio-confirm";

/**
 * Project Detail page logic
 */
export function registerProjectDetail(Alpine: any) {
  Alpine.data("projectDetail", (initialTab: string = "timeline") => alpineData({
    open: false,
    lightboxOpen: false,
    currentAsset: null,
    allAssets: [],
    activeTab: initialTab,

    init() {
      // Priority: Hash > initialTab
      this.activeTab = window.location.hash ? window.location.hash.slice(1) : initialTab;

      // Sync with location hash
      this.$watch("activeTab", (value: string) => {
        window.history.replaceState(null, "", "#" + value);

        // Adaptive Scroll Reset:
        // Since columns natively own their scroll context across all viewports,
        // we simply reset any defined column to the top on tab change.
        [".project-center-content", ".project-sidebar-left", ".project-sidebar-right"].forEach(
          (selector) => {
            const col = this.$el.querySelector(selector);
            if (col) col.scrollTo({ top: 0, behavior: "instant" });
          },
        );
      });

      window.addEventListener("hashchange", () => {
        this.activeTab = window.location.hash.slice(1) || initialTab;
      });

      // Lock scroll when lightbox is open
      this.$watch("lightboxOpen", (value: boolean) => {
        document.body.style.overflow = value ? "hidden" : "";
      });
    },

    async deleteProjectAsset(projectId: string, assetId: string, confirmMsg: string) {
      if (!(await studioConfirm(confirmMsg))) return;
      const StudioShared = (window as any).StudioShared;
      if (StudioShared && StudioShared.fetchWithOOB) {
        await StudioShared.fetchWithOOB("DELETE", `/api/projects/${projectId}/assets`, {
          asset_ids: [assetId],
        });
      }
    },

    openLightbox(asset: any) {
      this.currentAsset = asset;
      this.lightboxOpen = true;
    },

    next() {
      const media = this.allAssets.filter(
        (a: any) =>
          a.content_type &&
          (a.content_type.startsWith("image/") || a.content_type.startsWith("video/")),
      );
      if (media.length === 0) return;
      const idx = media.findIndex((a: any) => a.id === this.currentAsset.id);
      if (idx === -1) {
        this.currentAsset = media[0];
        return;
      }
      this.currentAsset = media[(idx + 1) % media.length];
    },

    prev() {
      const media = this.allAssets.filter(
        (a: any) =>
          a.content_type &&
          (a.content_type.startsWith("image/") || a.content_type.startsWith("video/")),
      );
      if (media.length === 0) return;
      const idx = media.findIndex((a: any) => a.id === this.currentAsset.id);
      if (idx === -1) {
        this.currentAsset = media[media.length - 1];
        return;
      }
      this.currentAsset = media[(idx - 1 + media.length) % media.length];
    },
  }));
}
